module.exports = __webpack_public_path__ + "static/img/pic7.bca37e02.png";